import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  containerPaper: {
    padding: theme.spacing(2),
  },
  containerChild: {
    padding: theme.spacing(2),
  },
  text: {
    fontSize: theme.typography.subtitle1.fontSize,
    marginBottom: theme.spacing(0),
  },
}));

export default useStyles;
